import { Enums } from '@configur-tech/upit-core-types';
import {
  faArrowLeft,
  faChevronDown,
  faChevronUp,
  faCog,
  faDatabase,
  faInfoCircle,
  faShieldAlt,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeContext } from 'styled-components';
import useCMS from '../../../hooks/cms/useCMS';
import { BackNavigationItem, defaultTheme } from '../../../main/theme';
import {
  resetDataviewStage,
  updateActiveProjectSubStage,
} from '../../../store/project-stage';
import {
  ConfigurationSubStage,
  ProjectConnectionCMSSubStage,
  ProjectConnectionPortalSubStage,
} from '../../../store/project-stage/initial-state';
import { RootState } from '../../../store/rootReducer';
import NavItem from '../../Navigation/NavItem';
import NavTitle from '../../Navigation/NavTitle';
import {
  NavigationAccordion,
  NavigationAccordionContent,
  NavigationAccordionTitle,
  NavigationNavItem,
} from '../ProjectItemNavigation/styled';

const NavIcons = {
  [ProjectConnectionCMSSubStage.NAME]: faInfoCircle,
  [ProjectConnectionCMSSubStage.DATA]: faDatabase,
  [ProjectConnectionCMSSubStage.ACCESS]: faCog,
};

const ProjectItemCMSNavigation: FC = () => {
  const dispatch = useDispatch();
  const themeContext = useContext(ThemeContext);
  const { cms } = useCMS();

  const projectStageState = useSelector(
    (state: RootState) => state.projectStage,
  );
  const cmsStage = projectStageState.stages[Enums.ConnectionType.CMS];
  const activeSubStage = cmsStage.activeSubStage;

  const [accordionGroups, setAccordionGroups] = useState<
    Record<string, boolean>
  >({ [ProjectConnectionCMSSubStage.CONFIGURATION]: true });

  return (
    <>
      <BackNavigationItem
        className={'back'}
        key={`cms-stage-back`}
        onClick={() => dispatch(resetDataviewStage())}
        isActive={false}
      >
        <FontAwesomeIcon
          icon={faArrowLeft}
          color={defaultTheme.colors.system.white}
        />

        <NavTitle text={'Back To Workspaces'} />
      </BackNavigationItem>

      {Object.values(cmsStage.subStages)
        .filter(
          (subStage) =>
            subStage.subStage !== ProjectConnectionCMSSubStage.CONFIGURATION &&
            subStage.subStage !== ProjectConnectionCMSSubStage.ACCESS,
        )
        .map((subStage) => {
          const subStageName =
            subStage.subStage as ProjectConnectionCMSSubStage;

          return (
            <NavItem
              disabled={
                subStageName === ProjectConnectionCMSSubStage.DATA && !cms?.name
              }
              key={`form-stage-${subStageName}`}
              onClick={() =>
                dispatch(updateActiveProjectSubStage(subStageName))
              }
              isActive={activeSubStage === subStageName}
            >
              <FontAwesomeIcon
                icon={NavIcons[subStageName]}
                color={defaultTheme.colors.system.white}
              />

              <NavTitle text={subStage.title} />
            </NavItem>
          );
        })}

      {/* Configuration accordion nav */}
      {cms?._id && (
        <NavigationAccordion>
          <div key={`${ProjectConnectionCMSSubStage.CONFIGURATION}-0`}>
            <NavigationAccordionTitle
              active={
                !accordionGroups[ProjectConnectionCMSSubStage.CONFIGURATION]
              }
              index={0}
              onClick={() =>
                setAccordionGroups({
                  ...accordionGroups,
                  [ProjectConnectionCMSSubStage.CONFIGURATION]:
                    !accordionGroups[
                      ProjectConnectionCMSSubStage.CONFIGURATION
                    ],
                })
              }
            >
              <div style={{ width: '100%', display: 'flex' }}>
                <NavTitle
                  text={
                    cmsStage.subStages.find(
                      (s) =>
                        s.subStage ===
                        ProjectConnectionCMSSubStage.CONFIGURATION,
                    )?.title || 'Config'
                  }
                />

                <FontAwesomeIcon
                  icon={
                    !accordionGroups[Enums.DatasetStage.CONFIGURATION]
                      ? faChevronUp
                      : faChevronDown
                  }
                  color={themeContext.colors.system.white}
                />
              </div>
            </NavigationAccordionTitle>

            <NavigationAccordionContent
              active={
                !accordionGroups[ProjectConnectionCMSSubStage.CONFIGURATION]
              }
            >
              <div>
                <NavigationNavItem
                  onClick={() => {
                    dispatch(
                      updateActiveProjectSubStage(
                        ProjectConnectionPortalSubStage.ACCESS,
                      ),
                    );
                  }}
                  isActive={
                    activeSubStage === ProjectConnectionCMSSubStage.ACCESS
                  }
                >
                  <FontAwesomeIcon
                    icon={faShieldAlt}
                    color={themeContext.colors.system.white}
                    style={{ marginRight: themeContext.margin.standard }}
                  />

                  <NavTitle
                    text={ProjectConnectionPortalSubStage.ACCESS}
                    isActive={true}
                  />
                </NavigationNavItem>
              </div>
              {cms?._id && (
                <div>
                  <NavigationNavItem
                    onClick={() => {
                      dispatch(
                        updateActiveProjectSubStage(
                          ProjectConnectionCMSSubStage.CONFIGURATION,
                        ),
                      );
                    }}
                    isActive={
                      activeSubStage ===
                      ProjectConnectionCMSSubStage.CONFIGURATION
                    }
                  >
                    <FontAwesomeIcon
                      icon={faCog}
                      color={themeContext.colors.system.white}
                      style={{ marginRight: themeContext.margin.standard }}
                    />

                    <NavTitle
                      text={ConfigurationSubStage.ADVANCED}
                      isActive={true}
                    />
                  </NavigationNavItem>
                </div>
              )}
            </NavigationAccordionContent>
          </div>
        </NavigationAccordion>
      )}
    </>
  );
};

export default ProjectItemCMSNavigation;
